import styled from "styled-components";

const Absolute = styled.div<{ zIndex?: number }>`
  position: absolute;
  z-index: ${(props) => props.zIndex || "initial"};
`;

export default Absolute;
